var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduledCampaignsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.31 10.84C46.31 6.59 42.85 3.13 38.6 3.13H34.03V1.44C34.03 0.66 33.37 0 32.59 0C31.81 0 31.15 0.66 31.15 1.44V3.13H15.18V1.44C15.18 0.63 14.55 0 13.74 0C12.93 0 12.3 0.66 12.3 1.44V3.13H7.73C3.46 3.13 0 6.59 0 10.84V40.79C0 45.04 3.46 48.5 7.71 48.5H38.6C42.85 48.5 46.31 45.04 46.31 40.79V10.84ZM43.42 40.79C43.46 42.08 42.98 43.32 42.08 44.24C41.18 45.16 39.97 45.67 38.66 45.67H7.71C5.05 45.67 2.89 43.51 2.89 40.85V18.61H43.43V40.79H43.42ZM43.48 15.73H2.89V10.84C2.89 8.18 5.05 6.02 7.71 6.02H12.28V7.71C12.28 8.49 12.94 9.15 13.72 9.15C14.5 9.15 15.16 8.49 15.16 7.71V6.02H31.2V7.71C31.2 8.49 31.86 9.15 32.64 9.15C33.42 9.15 34.08 8.49 34.08 7.71V6.02H38.65C41.31 6.02 43.47 8.18 43.47 10.84V15.73H43.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2098 24.4395H9.58984V29.0595H14.2098V24.4395Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4698 24.4395H20.8398V29.0595H25.4698V24.4395Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7198 24.4395H32.0898V29.0595H36.7198V24.4395Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7198 24.4395H32.0898V29.0595H36.7198V24.4395Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7198 24.4395H32.0898V29.0595H36.7198V24.4395Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2098 35.6895H9.58984V40.3095H14.2098V35.6895Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8398 40.3095H25.4598V35.6895H20.8398V40.3095Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7098 35.6895H32.0898V40.3095H36.7098V35.6895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledCampaignsIcon);
export default __webpack_public_path__ + "static/media/scheduledCampaignsIcon.4f849d9bedf79163675c46df509be87a.svg";
export { ForwardRef as ReactComponent };